export const isMobile = () => /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
export const isAndroid = () => /Android/i.test(navigator.userAgent)
